/**
 * Formata a variação % vs período anterior. Duas casas decimais — com uma só,
 * um valor como -0,03% colapsaria para "0,0%", escondendo o sinal (mesma
 * precisão decidida no backend, no musa-agreements: /ops/generator/analytics/totals).
 * Separador decimal é ponto, não vírgula — como no mock do Figma (-0.03%).
 */
export const formatVariationPercent = (value: number): string => {
  const sign = value >= 0 ? "+" : "";
  return `${sign}${value.toFixed(2)}%`;
};

/**
 * Direção do ícone de tendência no chip de variação: segue o sinal real do
 * valor. O Figma não documenta essa regra (mostra só um exemplo estático,
 * -0,03%, ícone sem rotação) — decisão técnica: um valor positivo com ícone
 * de queda seria enganoso independente da cor do texto.
 */
export type TrendDirection = "up" | "down";

export const getVariationTrendDirection = (value: number): TrendDirection =>
  value >= 0 ? "up" : "down";
